import React from "react";
import Heading from "../ui/Heading";
import Slider from "react-slick";
import { Container, Image } from "react-bootstrap";
import Halo from "../Assets/img/ring-style/new/halo.webp";
import Solitaire from "../Assets/img/ring-style/new/solitaire.webp";
import ThreeStone from "../Assets/img/ring-style/new/three-stone.webp";
import Eternity from "../Assets/img/ring-style/new/eternity-ring.webp";
import ShapeColor from "../Assets/img/ring-style/new/shop_by_color.webp";
import Fancy from "../Assets/img/ring-style/new/fancy.webp";
import LeftIcon from "../../../../Assets/images/icon/left.svg"
import RightIcon from "../../../../Assets/images/icon/right.svg"
import { useTranslation } from 'react-i18next';
import LocalizedLink from "../../../../Components/LocalizedLink";

const ShopRingByStyle = () => {
  const { t } = useTranslation();

  const LeftArrow = (props) => {
    return (
      <div className="slick-arrow slick-prev" {...props}>
        <img src={LeftIcon} alt="Left Arrow" />
      </div>
    );
  };

  const RightArrow = (props) => {
    return (
      <div className="slick-arrow slick-next" {...props}>
        <img src={RightIcon} alt="Right Arrow" />
      </div>
    );
  };



let settings2 = {
  dots: false,
  infinite: true,
  speed: 800,              // smoother transition
  cssEase: "ease-in-out",  // smooth animation
  accessibility: true,
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 1,

  autoplay: true,
  autoplaySpeed: 2500,     // time between slides
  pauseOnHover: true,
  pauseOnFocus: false,

  prevArrow: <LeftArrow />,
  nextArrow: <RightArrow />,

  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1, // smoother on mobile
        arrows: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
      },
    },
  ],
};


  return (
    <section className="shop-ring-by-style">
      <Container fluid className="home-showcase-container">
        <Heading>
          <h2>{t('shopRingByStyle.heading')}</h2>
          <p>{t('shopRingByStyle.subheading')}</p>
        </Heading>
        <div className="inner-shop-diamond-shape">
          <Slider {...settings2}>
            <div className="item">
              <LocalizedLink to="/engagement-rings/color=fancy" className="pt-0">
                <Image  loading="lazy" src={Fancy} alt="Fancy" />
              </LocalizedLink>
              <LocalizedLink to="/engagement-rings/color=fancy">{t('shopRingByStyle.styles.fancy')}</LocalizedLink>
            </div>
            <div className="item">
              <LocalizedLink to="/engagement-rings/style=Halo" className="pt-0">
                <Image  loading="lazy" src={Halo} alt="Halo" />
              </LocalizedLink>
              <LocalizedLink to="/engagement-rings/style=Halo">{t('shopRingByStyle.styles.halo')}</LocalizedLink>
            </div>
            <div className="item">
              <LocalizedLink to="/engagement-rings/style=Solitaire" className="pt-0">
                <Image  loading="lazy" src={Solitaire} alt="Solitaire" />
              </LocalizedLink>
              <LocalizedLink to="/engagement-rings/style=Solitaire">{t('shopRingByStyle.styles.solitaire')}</LocalizedLink>
            </div>
            <div className="item">
              <LocalizedLink to="/engagement-rings/style=Three%20stone" className="pt-0">
                <Image  loading="lazy" src={ThreeStone} alt="ThreeStone" />
              </LocalizedLink>
              <LocalizedLink to="/engagement-rings/style=Three%20stone">{t('shopRingByStyle.styles.threeStone')}</LocalizedLink>
            </div>
            {/* <div className="item">
              <LocalizedLink to="/engagement-rings/style=Single Row" className="pt-0">
                <Image  loading="lazy" src={SingleRow} alt="SingleRow" />
              </LocalizedLink>
              <LocalizedLink to="/engagement-rings/style=Single Row">Single Row</LocalizedLink>
            </div> */}
            <div className="item">
              <LocalizedLink to="/wedding-rings" className="pt-0">
                <Image  loading="lazy" src={Eternity} alt="Eternity" />
              </LocalizedLink>
              <LocalizedLink to="/wedding-rings">{t('shopRingByStyle.styles.eternityRings')}</LocalizedLink>
            </div>
               <div className="item">
              <LocalizedLink to="/engagement-rings/color=Emerald" className="pt-0">
                <Image  loading="lazy" src={ShapeColor} alt="Eternity" />
              </LocalizedLink>
              <LocalizedLink to="/engagement-rings/color=Emerald">{t('shopRingByStyle.styles.colorGems')}</LocalizedLink>
            </div>
          </Slider>
        </div>
      </Container>
    </section>
  );
};

export default ShopRingByStyle;
